import React, { useState } from "react";
import { registerClinic } from "./api";

const ClinicRegistration = () => {
  // Состояние формы
  const [formData, setFormData] = useState({
    name: "",
    amocrm_subdomain: "",
    client_id: "",
    client_secret: "",
    redirect_url: "",
    auth_code: "",
    amocrm_pipeline_id: "",
    monthly_limit: 100,
  });

  // Состояние для отслеживания процесса отправки и результатов
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitResult, setSubmitResult] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  // Обработчик изменения полей формы
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Обработка числовых полей
  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "" ? "" : Number(value),
    }));
  };

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setSubmitResult(null);
    setSubmitError(null);

    try {
      const response = await registerClinic(formData);
      setSubmitResult(response);
    } catch (error) {
      setSubmitError(
        error.message || "Произошла ошибка при регистрации клиники"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="py-6">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold mb-4">
          Регистрация <span className="gradient-text">новой клиники</span>
        </h1>
        <p className="text-gray-400 text-xl max-w-2xl mx-auto">
          Подключите медицинский центр к современной системе
        </p>
      </div>

      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-300 mb-8">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {/* Название клиники */}
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Название клиники *
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Название клиники"
                  className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                />
              </div>

              {/* Поддомен AmoCRM */}
              <div>
                <label
                  htmlFor="amocrm_subdomain"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Поддомен AmoCRM *
                </label>
                <div className="flex items-center">
                  <input
                    id="amocrm_subdomain"
                    name="amocrm_subdomain"
                    type="text"
                    value={formData.amocrm_subdomain}
                    onChange={handleChange}
                    required
                    placeholder="example"
                    className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                  />
                  <span className="ml-2 text-gray-400">.amocrm.ru</span>
                </div>
              </div>

              {/* Client ID */}
              <div>
                <label
                  htmlFor="client_id"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Client ID *
                </label>
                <input
                  id="client_id"
                  name="client_id"
                  type="text"
                  value={formData.client_id}
                  onChange={handleChange}
                  required
                  placeholder="Client ID из настроек интеграции"
                  className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                />
              </div>

              {/* Client Secret */}
              <div>
                <label
                  htmlFor="client_secret"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Client Secret *
                </label>
                <input
                  id="client_secret"
                  name="client_secret"
                  type="text"
                  value={formData.client_secret}
                  onChange={handleChange}
                  required
                  placeholder="Client Secret из настроек интеграции"
                  className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                />
              </div>

              {/* URL перенаправления */}
              <div>
                <label
                  htmlFor="redirect_url"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  URL перенаправления *
                </label>
                <input
                  id="redirect_url"
                  name="redirect_url"
                  type="url"
                  value={formData.redirect_url}
                  onChange={handleChange}
                  required
                  placeholder="https://example.com/oauth"
                  className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                />
              </div>

              {/* Долгосрочный токен */}
              <div>
                <label
                  htmlFor="auth_code"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Долгосрочный токен AmoCRM *
                </label>
                <input
                  id="auth_code"
                  name="auth_code"
                  type="text"
                  value={formData.auth_code}
                  onChange={handleChange}
                  required
                  placeholder="Долгосрочный токен из AmoCRM"
                  className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                />
                <p className="text-xs text-gray-400 mt-1">
                  Вставьте долгосрочный токен из раздела ключей интеграции AmoCRM
                </p>
              </div>

              {/* ID воронки */}
              <div>
                <label
                  htmlFor="amocrm_pipeline_id"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  ID воронки в AmoCRM
                </label>
                <input
                  id="amocrm_pipeline_id"
                  name="amocrm_pipeline_id"
                  type="text"
                  value={formData.amocrm_pipeline_id}
                  onChange={handleChange}
                  placeholder="ID воронки для работы (опционально)"
                  className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                />
              </div>

              {/* Месячный лимит */}
              <div>
                <label
                  htmlFor="monthly_limit"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Месячный лимит
                </label>
                <input
                  id="monthly_limit"
                  name="monthly_limit"
                  type="number"
                  min="1"
                  value={formData.monthly_limit}
                  onChange={handleNumberChange}
                  placeholder="Месячный лимит обработки звонков"
                  className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                />
              </div>

            </div>

            {/* Кнопка отправки */}
            <div className="mt-8">
              <button
                type="submit"
                disabled={isSubmitting}
                className="gradient-button text-gray-900 font-medium py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 disabled:opacity-50 w-full md:w-auto"
              >
                {isSubmitting ? "Регистрация..." : "Зарегистрировать клинику"}
              </button>
            </div>
          </form>

          {/* Результат отправки */}
          {submitResult && (
            <div className="mt-6 p-4 bg-green-900 text-gray-900 rounded-md">
              <h3 className="font-medium text-lg mb-2">
                Клиника успешно зарегистрирована!
              </h3>
              <p>
                Клиника{" "}
                <strong>{submitResult.data?.name || formData.name}</strong>{" "}
                успешно зарегистрирована в системе.
              </p>
              {submitResult.data?.client_id && (
                <p className="mt-2">
                  Client ID:{" "}
                  <code className="bg-white px-2 py-1 rounded">
                    {submitResult.data.client_id}
                  </code>
                </p>
              )}
            </div>
          )}

          {/* Ошибка отправки */}
          {submitError && (
            <div className="mt-6 p-4 bg-red-900 text-gray-900 rounded-md">
              <h3 className="font-medium text-lg mb-2">
                Ошибка при регистрации
              </h3>
              <p>{submitError}</p>
            </div>
          )}

          {/* Информация по полям */}
          <div className="mt-8 p-4 bg-gray-700 rounded-md text-gray-300 text-sm">
            <h3 className="font-medium text-base mb-3 text-gray-100">
              Информация по заполнению полей:
            </h3>
            <ul className="space-y-2 list-disc pl-5">
              <li>
                <strong>Название клиники</strong> - официальное название клиники
                для идентификации в системе
              </li>
              <li>
                <strong>Поддомен AmoCRM</strong> - указывается только поддомен
                без домена, например:{" "}
                <code className="bg-white px-1 rounded">example</code> из
                example.amocrm.ru
              </li>
              <li>
                <strong>Client ID и Client Secret</strong> - данные для доступа
                из интеграции AmoCRM
              </li>
              <li>
                <strong>URL перенаправления</strong> - должен точно совпадать с
                указанным в настройках интеграции AmoCRM
              </li>
              <li>
                <strong>Долгосрочный токен AmoCRM</strong> - постоянный токен из
                раздела ключей интеграции AmoCRM
              </li>
              <li>
                <strong>ID воронки</strong> - опциональное поле, укажите ID
                воронки в AmoCRM, с которой будет работать система
              </li>
            </ul>
          </div>
        </div>
      </div>
  );
};

export default ClinicRegistration;
